export const ARCHIVE_TASTE_PROMPT_SURFACES = {
  homepageHero: {
    key: "homepageHero",
    fallbackPrompts: [
      "tense spy drama",
      "character-first mysteries",
      "90s-style sitcom",
    ],
  },
  homepageLowerPromo: {
    key: "homepageLowerPromo",
    fallbackPrompts: [
      "warm workplace comedy",
      "dark comedy about loss",
      "country-house intrigue",
      "murder mystery small town",
    ],
  },
  "shows-like-bottom": {
    key: "shows-like-bottom",
    fallbackPrompts: [
      "slow-burn conspiracy thriller",
      "character-first mystery",
      "sharp workplace comedy",
      "atmospheric supernatural drama",
    ],
  },
};

export const ARCHIVE_TASTE_PROMPT_SURFACE_KEYS = Object.keys(ARCHIVE_TASTE_PROMPT_SURFACES);
